import { jsx as e } from "react/jsx-runtime";
import { S as m } from "../../index-CCavb-1K.js";
import { c as o } from "../../index-BwYCDOHZ.js";
import { cn as d } from "../../utils/cn.js";
const u = o("font-sans antialiased", {
  variants: {
    alignment: {
      start: "text-start",
      center: "text-center",
      end: "text-end"
    },
    color: {
      primary: "text-text-primary",
      secondary: "text-text-secondary",
      "primary-inverted": "text-text-primary-inverted",
      danger: "text-text-danger",
      success: "text-text-success"
    },
    maxLines: {
      1: "line-clamp-1",
      2: "line-clamp-2",
      3: "line-clamp-3",
      4: "line-clamp-4",
      5: "line-clamp-5",
      6: "line-clamp-6"
    },
    textWrap: {
      balance: "text-balance",
      pretty: "text-pretty"
    },
    underline: {
      true: "underline"
    },
    variant: {
      t1: "py-[2px] text-t1",
      "t1-style-1": "py-[2px] text-t1-style-1",
      "t1-style-2": "text-t1-style-2",
      t2: "pb-[3px] pt-[1px] text-t2",
      "t2-style-1": "pb-[3px] pt-[1px] text-t2-style-1",
      "t2-style-2": "pb-[3px] pt-[1px] text-t2-style-2",
      "t2-style-3": "text-t2-style-3",
      t3: "text-t3",
      "t3-style-1": "text-t3-style-1",
      "t3-style-2": "text-t3-style-2"
    }
  }
}), S = ({
  alignment: r = "start",
  as: a = "p",
  asChild: s,
  children: t,
  className: x,
  color: p = "primary",
  maxLines: l,
  textWrap: n,
  underline: i,
  variant: y = "t1",
  ...c
}) => /* @__PURE__ */ e(
  m,
  {
    className: d(
      u({
        alignment: r,
        color: p,
        maxLines: l,
        textWrap: n,
        underline: i,
        variant: y,
        className: x
      })
    ),
    ...c,
    children: s ? t : /* @__PURE__ */ e(a, { children: t })
  }
);
export {
  S as Text
};
